import { render, staticRenderFns } from "./AllEmployees.vue?vue&type=template&id=890c49be&scoped=true"
import script from "./AllEmployees.vue?vue&type=script&lang=js"
export * from "./AllEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890c49be",
  null
  
)

export default component.exports